
import { Component, Vue, Prop, VModel } from 'vue-property-decorator'
import TreeitemDialog from '../dialogs/treeview.vue'

@Component({ name: 'TreeDropdown', components: { TreeitemDialog } })
export default class TreeDropdown extends Vue {
    @VModel() item!: null | Record<string, any>
    @Prop({ required: true }) itemType!: string
    @Prop({ default: false }) disabled!: boolean
    @Prop({ required: true }) flatItems!: Array<any>
    @Prop({ required: true }) projectId!: string

    dialog = false

    toggleDialog() {
        if (!this.disabled) {
            this.dialog = !this.dialog
        }
    }
}
